import { ModalWrapper } from 'src/components'
import { Formik } from 'formik'

import { useSettings, useUpdateTraicyHashtagsList } from 'src/hooks'
import { IHashTagsSettingsForm } from 'src/types'

import { useStyles } from '../form/styles'
import { SettingListItemsForm } from '../form/array-list-item-form'

interface IProps {
  open: boolean
  handleClose: () => void
}

export const HashTagsModal = ({ open, handleClose }: IProps) => {
  const { data: settings } = useSettings()
  const { mutate: updateHashtagsList } = useUpdateTraicyHashtagsList()

  const classes = useStyles()

  const initialTags = settings?.traicy_hash_tag_list || []

  const handleSubmit = async (values: IHashTagsSettingsForm) => {
    updateHashtagsList({ list: values.hashTags })
    handleClose()
  }

  return (
    <ModalWrapper open={open} onClose={handleClose} className={classes.modalWrapper}>
      <Formik initialValues={{ hashTags: initialTags, newTag: '' }} onSubmit={handleSubmit}>
        <SettingListItemsForm handleClose={handleClose} />
      </Formik>
    </ModalWrapper>
  )
}
